import {
  Component, Input, ViewEncapsulation, Output, EventEmitter, OnChanges,
  ChangeDetectorRef, Inject, PLATFORM_ID, OnInit, HostListener, OnDestroy
} from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';
import { BreakpointObserver } from '@angular/cdk/layout';

const LINK_SRC = 'LINK_SRC';
const ALT_IMG = 'ALT_IMG';
const IMG = `<img src="${LINK_SRC}" alt="${ALT_IMG}" onerror="this.src = '/assets/imgs/image-gallery-default.png'; this.style.objectFit = 'scale-down'">`;
const SPACING = 24;
// tslint:disable-next-line: max-line-length
const VIDEO = `<iframe src="${LINK_SRC}" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>`;

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CarouselComponent implements OnChanges, OnInit {

  @Input() listCarousel = [];
  @Input() index = 0;
  @Input() typeHtml = 'img';
  @Input() theme: 'modal' | 'landpage' = 'landpage';
  @Input() thumbnail: true | false = false;

  @Output() openModal: EventEmitter<{ index: number }> = new EventEmitter<{ index: number }>();

  itemNext: SafeHtml;
  itemPrevious: SafeHtml;
  itemActual: SafeHtml;
  isBrowser: boolean;

  isMobile: boolean;

  constructor(
    private breakPoint: BreakpointObserver,
    private byPass: DomSanitizer,
    private cd: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnChanges() {
    this.init();
  }

  ngOnInit() {
    this.breakPoint.observe(['(max-width: 768px)'])
      .subscribe((state) => {
        this.isMobile = state.matches;
      });

    this.onResize();
  }

  @HostListener('window:resize', [])
  onResize() {
    if (this.isBrowser) {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'ArrowLeft') { this.click(-1); }
    if (event.key === 'ArrowRight') { this.click(1); }
  }

  init() {
    if (this.typeHtml === 'img') {
      this.buildTemplate(IMG);
    } else {
      this.buildTemplate(VIDEO);
    }
    this.cd.detectChanges();

    if (this.isBrowser) {
      this.updateScroll();
    }
  }

  click(value) {
    const verification = this.index + value;
    if (verification < 0 || verification > this.listCarousel.length - 1) {
      return;
    }

    this.index += value;
    this.init();
  }

  receiveIndex(event) {
    this.index = event.index;
    this.init();
  }

  updateScroll() {
    const elements = {
      parent: document.getElementById('product-thumbnail-list'),
      child: document.getElementsByClassName('product-thumbnail__active')[0] as HTMLScriptElement
    };

    if (!elements.parent || !elements.child) {
      return;
    }
    const parent = elements.parent.getBoundingClientRect();
    const child = elements.child.getBoundingClientRect();

    const { left: elLeft, right: elRight } = child;
    const { left: parentLeft, right: parentRight } = parent;

    if (elRight > parentRight) {
      elements.parent.scrollLeft += elements.child.offsetWidth + SPACING;
    } else if (elLeft < parentLeft) {
      elements.parent.scrollLeft -= elements.child.offsetWidth + SPACING;
    }
  }

  buildTemplate(constReplace) {
    if (this.listCarousel.length > 0) {
      const src = this.listCarousel[this.index].linkHtml;
      const alt = this.listCarousel[this.index].alt?.replace(/"/g, '');

      const elementWithSrc = this.setElementSrc(src, constReplace);
      const elementWithSrcAndAlt = this.setElementAlt(elementWithSrc, alt);

      this.itemActual = this.byPassHtml(elementWithSrcAndAlt);
      this.itemPrevious = this.disabledPrevious() ? '' :
        this.byPassHtml(this.setElementSrc(this.verifyElementHtml(-1), constReplace));
      this.itemNext = this.disabledNext() ? '' :
        this.byPassHtml(this.setElementSrc(this.verifyElementHtml(1), constReplace));
    }
  }

  private setElementAlt(element: string, alt: string) {
    return this.replaceHtml(ALT_IMG, alt, element);
  }

  private setElementSrc(valueReplace: string, constReplace) {
    return this.replaceHtml(LINK_SRC, valueReplace, constReplace);
  }

  verifyElementHtml(valuePlus): string {
    const element = this.listCarousel[this.index + valuePlus];
    return element && element.linkHtml ? element.linkHtml : '';
  }

  replaceHtml(replace, valueReplace, constReplace): string {
    const regex = new RegExp(replace, 'g');
    return constReplace.replace(regex, valueReplace);
  }

  byPassHtml(html: string) {
    return this.byPass.bypassSecurityTrustHtml(html);
  }

  clickImgCurrent() {
    this.openModal.emit({ index: this.index });
    if (this.theme === 'modal' && !this.isMobile) {
      window.open(this.listCarousel[this.index].linkModal, '_blank');
    }
  }

  disabledNext() {
    return this.index >= this.listCarousel.length - 1;
  }

  disabledPrevious() {
    return this.index <= 0;
  }

  isIpad() {
    return false;
  }

}
